import posthog from 'posthog-js';
import { getConfig } from '@/constants/config';
import { environment } from '@/utils/env.utils';

/** Super properties attached to every PostHog event. Call again after `posthog.reset()`, which clears them. */
export const registerBasePostHogSuperProperties = () => {
  posthog.register({
    country: getConfig().country,
    web_app_version: environment.version,
  });
};
